import { Link } from "react-router-dom";
import { ChevronDown, UserCircle2 } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { useAccountLinks } from "@/components/useAccountLinks";

export const AccountMenu = () => {
  const acct = useAccountLinks();
  const { logout } = useAuth();
  if (!acct) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="chip-btn !px-4 !py-2 !text-[15px] flex items-center gap-2" data-testid="account-menu-trigger" aria-label="My account">
        <UserCircle2 size={18} /> {acct.user.name?.split(" ")[0] || "Account"} <ChevronDown size={14} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel data-testid="account-menu-label">
          <p className="text-navy">My account</p>
          <p className="text-xs text-muted-ink font-normal truncate">{acct.user.email}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {acct.links.map(([to, label, id]) => (
          <DropdownMenuItem key={id} asChild><Link to={to} data-testid={`account-${id}`}>{label}</Link></DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => logout().then(() => window.location.assign("/"))} data-testid="account-sign-out">Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
